import { useState, useEffect } from 'react'
import { apiClient } from '../services/api'
import type { ChargingSession, SessionInterval } from '@shared/types/session'

export function useSessions(admin = false) {
  const [sessions, setSessions] = useState<ChargingSession[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const path = admin ? '/api/manage/sessions' : '/api/sessions'
    setLoading(true)
    apiClient.get<{ items: ChargingSession[] }>(path)
      .then(r => setSessions(r.items))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false))
  }, [admin])

  async function getSessionIntervals(sessionId: string): Promise<SessionInterval[]> {
    const path = admin
      ? `/api/manage/sessions/${sessionId}`
      : `/api/sessions/${sessionId}`
    const r = await apiClient.get<{ intervals: SessionInterval[] }>(path)
    return r.intervals
  }

  return { sessions, loading, error, getSessionIntervals }
}
